"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "ursa-icon__753b3a50a",
  width: 24,
  height: 24,
  x: 0,
  y: 0
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9,
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 4.7c-1.49 0-2.719 1.19-2.719 2.687a.7.7 0 1 0 1.4 0c0-.701.58-1.287 1.32-1.287.737 0 1.317.586 1.317 1.288 0 .422-.229.671-.685.974-.553.366-1.334.988-1.334 2.174v.248a.7.7 0 1 0 1.4 0v-.248c0-.44.239-.697.707-1.007.54-.358 1.312-.973 1.312-2.141C14.718 8.892 13.49 7.7 12 7.7Zm-.8 8.3a.791.791 0 0 1 .795-.8.8.8 0 1 1-.795.8Z",
  clipRule: "evenodd",
  mask: "url(#ursa-icon__753b3a50a)"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HelpFillIcon24.js.map